import { extendTheme } from 'native-base';

import breakpoints from './breakpoints';
import colors from './colors';
import componentsTheme from './components';
import fontTheme from './font';
import shadowsTheme from './shadow';

const evidationTheme = extendTheme({
  breakpoints,
  colors,
  ...componentsTheme,
  ...fontTheme,
  ...shadowsTheme,
});

type EvidationThemeType = typeof evidationTheme;

declare module 'native-base' {
  interface ICustomTheme extends EvidationThemeType {}
}

export default evidationTheme;
